<template lang="pug">
.participe(:class="getClassName()")
  .participe-logo
    i.ap-Participa.participe-icon
    span Participa
    ayuda-button(:header="header" :footer="footer" @on-click="$emit('abrirGuiaParticipacionEvent')")
  .asu-subtitle(v-if="!header && !footer") Consulta, Sugerencia, Reclamo
  .icons-container
    .icons
      v-tooltip(bottom)
        template(#activator="{ on }")
          v-btn.v-btn--xsmall.pedido-documento(v-on="on" :depressed="header" :color="header ? 'white' : 'primary'" icon @click="$emit('sendMailDialogOpenEvent','Pedido de Documento')")
            i.ap-Pedido-documento.icon-size-custom
        span Solicitar Documento
      v-tooltip(bottom)
        template(#activator="{ on }")
          v-btn.v-btn--xsmall.comentario(v-on="on" :depressed="header" :color="header ? 'white' : 'primary'" dark icon @click="$emit('sendMailDialogOpenEvent', 'Comentario')")
            i.ap-Comentario.icon-size-custom
        span Comentario
      v-tooltip(bottom)
        template(#activator="{ on }")
          v-btn.v-btn--xsmall.reclamo(v-on="on" :depressed="header" :color="header ? 'white' : 'primary'" dark icon @click="$emit('sendMailDialogOpenEvent', 'Reclamo')")
            i.ap-reclamo.icon-size-custom
        span Reclamo
      v-tooltip(bottom)
        template(#activator="{ on }")
          v-btn.v-btn--xsmall(v-on="on" :depressed="header" :color="header ? 'white' : 'primary'" dark icon @click="$emit('sendMailDialogOpenEvent', 'Otro')")
            i.material-icons.otro add
        span Otro
      v-tooltip(bottom)
        template(#activator="{ on }")
          v-btn.v-btn--xsmall.whatsapp(v-on="on" icon dark :depressed="header" :color="header ? 'white' : 'primary'" :disabled="haveWhatsapp()" @click="whatsapp()")
            i.ap-whatsapp
        span Whatsapp
      v-tooltip(v-model="speedDialTooltip" right)
        template(#activator="{ on }")
          v-speed-dial(v-model="speedDial" :direction="header ? 'bottom' : 'top'" :open-on-hover="false")
            template(#activator)
              v-btn.v-btn--xsmall.share-btn(v-on="on" v-model="speedDial" :depressed="header" :color="header ? 'white' : 'primary'" fab small)
                v-icon.share share
                v-icon close
            v-btn.v-btn--xsmall.speed-dial-btn(fab color="white" @click="twitter()")
              i.ap-twitter
            v-btn.v-btn--xsmall.speed-dial-btn(fab color="white" @click="instagram()")
              i.ap-instagram
            v-btn.v-btn--xsmall.speed-dial-btn(fab color="white" @click="facebook()")
              i.ap-facebook
        span Compartir
  WhatsappDialog(:openDialog="showWhatsappDialog" @closeWhatsappDialog="showWhatsappDialog=false")
</template>

<script>
import { mapGetters } from 'vuex'
import inRootMixin from '@/mixins/in-root.js'
import { hasValue } from '@/utils/object'

export default {
  components: {
    'ayuda-button': _ => import('./AyudaButton'),
    WhatsappDialog: _ => import('@/components/WhatsappDialog')
  },
  methods: {
    twitter () {
      open(`https://twitter.com/intent/tweet?text=${this.buildMessage()}`, '_blank')
    },
    facebook () {
      open(`https://www.facebook.com/sharer/sharer.php?u=${this.link}`, 'pop')
    },

    instagram () {
      open(`http://instagram.com/asuparticipa/`, '_blank')
    },

    whatsapp () {
      if (this.$router.currentRoute.query && hasValue(this.$router.currentRoute.query)) {
        if (this.getProjectInfo) {
          if (this.getProjectInfo.whatsapp && this.getProjectInfo.whatsapp !== '') {
            open(`http://wa.me/${this.getProjectInfo.whatsapp}`, '_blank')
          } else {
            this.showWhatsappDialog = true
          }
        } else {
          this.$emit('sendWhatsappMessageDialogEvent', 'Whatsapp')
        }
      } else {
        this.$emit('sendWhatsappMessageDialogEvent', 'Whatsapp')
      }
    },

    buildMessage () {
      return `Mira el proyecto de ASU Participa: ${this.data}, siguenos en @AsuParticipa`
    },

    getClassName () {
      return `${this.isMapView ? 'is-in-map' : ''} ${this.header ? 'is-in-header' : ''} ${this.footer ? 'is-in-footer' : ''}`
    },

    haveWhatsapp () {
      if (!this.header && !this.footer) {
        if (this.getProjectInfo) {
          if (this.getProjectInfo.whatsapp && this.getProjectInfo.whatsapp !== '') {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      }
      return false
    }
  },
  mixins: [ inRootMixin ],
  props: {
    title: {
      default: 'Participa',
      type: String
    },
    description: {
      default: 'Envía tu comentario para Asu participa',
      type: String
    },
    data: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    header: {
      type: Boolean,
      default: false
    },
    footer: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showWhatsappDialog: false,
    speedDial: false,
    speedDialTooltip: false
  }),
  computed: {
    ...mapGetters([ 'isMapView', 'isDetailView', 'getProjectInfo' ])
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/variables'

.participe {
  position: relative
  margin: auto
  box-sizing: border-box
  text-decoration: none
  font-size: 1.2rem
  font-weight: 700
  vertical-align: middle
  padding: $f5px $f25px $f4px
  &.is-in-map {
    max-width: $f300px
  }
  &.is-in-header {
    color: white
    padding: 0
    max-width: $f400px
    display: flex
    align-items: center
    .v-btn {
      margin: $f6px $f8px
      &.v-btn--icon.v-btn--xsmall,
      &.v-btn--floating.v-btn--xsmall {
        min-width: $participa-icon-size
        height: $participa-icon-size !important
        width: $participa-icon-size !important
        .material-icons {
          min-width: $participa-icon-size
        }
      }
      i {
        color: $color_0
      }
    }
    .icons-container {
      display: inline-block
    }
    .participe-logo {
      display: flex
      align-items: center
    }
    .participe-icon {
      color: white
      font-size: $f17px
      flex-basis: $f20px
    }
  }
  &.is-in-footer {
    background: $color_0
    border-radius: 1.5rem
    display: flex
    flex-direction: column
    height: 12rem
    justify-content: space-around
    padding-bottom: 1rem
    padding-top: 1rem
    .participe-icon {
      color: white
    }
    .participe-logo {
      align-items: center
      color: white
      display: flex
      font-size: 2.5rem
      font-weight: 500
      width: auto
    }
    .asu-subtitle {
      display: none
    }
    .icons-container {
      .v-btn--xsmall {
        background-color: white !important
        height: 3.5rem
        width: 3.5rem
        margin-left: .5rem
        margin-right: .5rem
        i {
          color: $color_0
          font-size: 1.5rem
        }
        .ap-reclamo {
          font-size: 1rem
        }
        .material-icons {
          font-size: 2.5rem
        }
        .material-icons .otro {
          font-size: 2.5rem
        }
      }
    }
  }
  &:not(.is-in-header) {
    border: 3px solid rgb(13, 37, 99)
    color: rgb(13, 37, 99)
    .icons {
      margin-top: $f10px
    }
    .participe-icon {
      font-size: $f40px
    }
  }
}

.participe-logo {
  display: inline-block
  width: $f140px
}

.participe-icon {
  color: $color_0
  vertical-align: middle
  font-family: Raleway
}

.icons {
  display: flex
}

.v-btn {
  &.v-btn--xsmall {
    margin-top: 0
    margin-bottom: 0
    &.speed-dial-btn {
      margin-top: $f5px
      margin-bottom: $f5px
    }
    &.reclamo i {
      font-size: $f9px
    }
    &.whatsapp i {
      font-size: $f14px
    }
    &.whatsapp.v-btn--disabled i {
      color: white
    }
    &.whatsapp.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--outline) {
      background-color: gray !important
    }
  }
}

.is-in-footer.v-btn.v-btn--xsmall {
  background-color: $color_0 !important
  height: 25px;
  padding: 0
  width: 24px
}

.is-in-footer.material-icons.otro {
  margin: 0
}

.v-speed-dial .v-btn {
  margin-left: 0
  &.share-btn {
    margin-right: 0
  }
  &:not(.share-btn) {
    margin-right: 0
    i {
      color: $color_0
    }
  }
}

.asu-subtitle {
  font-size: $f11px
}

@media (max-width: 600px){

  .participe.is-in-footer .icons-container button{
    height: 10vw !important;
    width: 10vw !important;
    margin: 5px !important;
  }

  .participe.is-in-footer .participe-logo span{
    font-size: 1.8rem;
  }

  .participe.is-in-footer .icon-size-custom{
    font-size: 1rem !important;
  }

  .participe.is-in-footer .ap-reclamo.icon-size-custom{
    font-size: 0.8rem !important;
  }

  .participe.is-in-footer .material-icons{
    font-size: 1.5rem !important;
  }

  .participe.is-in-footer .ap-whatsapp{
    font-size: 1.3rem;
  }

  .participe.is-in-footer{
    padding: 5px !important;
    height: 10rem !important;
  }

  .participe.is-in-header button{
    margin: 2.5px !important;
  }
}
</style>
